var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoonOutOfStock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.7499C4.05228 10.7499 4.5 10.3022 4.5 9.74988C4.5 9.19759 4.05228 8.74988 3.5 8.74988C2.94772 8.74988 2.5 9.19759 2.5 9.74988C2.5 10.3022 2.94772 10.7499 3.5 10.7499Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.7499C11.0523 10.7499 11.5 10.3022 11.5 9.74988C11.5 9.19759 11.0523 8.74988 10.5 8.74988C9.94772 8.74988 9.5 9.19759 9.5 9.74988C9.5 10.3022 9.94772 10.7499 10.5 10.7499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.25012H4C3.72386 3.25012 3.5 3.47398 3.5 3.75012V6.25012C3.5 6.52626 3.72386 6.75012 4 6.75012H6.5C6.77614 6.75012 7 6.52626 7 6.25012V3.75012C7 3.47398 6.77614 3.25012 6.5 3.25012Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 3.25012H8.25C7.97386 3.25012 7.75 3.47398 7.75 3.75012V6.25012C7.75 6.52626 7.97386 6.75012 8.25 6.75012H10.75C11.0261 6.75012 11.25 6.52626 11.25 6.25012V3.75012C11.25 3.47398 11.0261 3.25012 10.75 3.25012Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0H6C5.72386 0 5.5 0.223858 5.5 0.5V2C5.5 2.27614 5.72386 2.5 6 2.5H9C9.27614 2.5 9.5 2.27614 9.5 2V0.5C9.5 0.223858 9.27614 0 9 0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.5H2.75V1.5C2.75 1.493 2.746 1.4865 2.7455 1.4795C2.745 1.4725 2.75 1.466 2.75 1.4585C2.74974 1.27068 2.67501 1.09062 2.54219 0.957807C2.40938 0.824995 2.22932 0.750265 2.0415 0.75H0.5C0.367392 0.75 0.240215 0.802678 0.146447 0.896447C0.0526784 0.990215 0 1.11739 0 1.25C0 1.38261 0.0526784 1.50979 0.146447 1.60355C0.240215 1.69732 0.367392 1.75 0.5 1.75H1.75V7.5C1.75 7.76522 1.85536 8.01957 2.04289 8.20711C2.23043 8.39464 2.48478 8.5 2.75 8.5H11.5C11.6326 8.5 11.7598 8.44732 11.8536 8.35355C11.9473 8.25979 12 8.13261 12 8C12 7.86739 11.9473 7.74021 11.8536 7.64645C11.7598 7.55268 11.6326 7.5 11.5 7.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoonOutOfStock);
export default __webpack_public_path__ + "static/media/soon-out-of-stock.23c1ff39.svg";
export { ForwardRef as ReactComponent };